<!--
 * @Author: your name
 * @Date: 2020-12-16 10:13:44
 * @LastEditTime: 2022-10-27 14:06:08
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/ExpireDateInput/index.vue
-->
<style scoped lang="sass">
.expire_date_input
  display: flex

.line
  transform: rotate(20deg)
  align-self: flex-end
  height: 25PX
  width: 1PX
  margin: 0 10PX 2PX 15PX
  background: #D4D4D4
  color: #fff

.month,
.year
  flex: 1

::v-deep
  input::-webkit-input-placeholder
    color: rgba(51, 68, 85, 0.45)
    font-size: 16px

</style>
<style lang="sass">
.creditcard-expiry-date-input input
  text-align: center !important
  padding: 0 !important
</style>

<template lang="pug">
.expire_date_input
  py-input.month(
    placeholder="MM"
    maxlength="2"
    title="Expiry date (mm/yy)"
    title-width="150px"
    type="number"
    :enableFloat="false"
    :value="monthValue"
    style="max-width: 40px"
    :ref="'creditCardMonth'"
    class="creditcard-expiry-date-input"
    @change="handleMonthInput"
    v-bind="$attrs"
  )
  .line .
  py-input.year(
    placeholder="YY"
    type="number"
    maxlength="2"
    :enableFloat="false"
    :value="yearValue"
    :ref="'creditCardYear'"
    style="max-width: 40px"
    class="creditcard-expiry-date-input"
    @change="handleYearInput"
    @pyBlur="handleBlur"
    v-bind="$attrs"
  )
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  model: {
    prop: 'expire',
    event: 'changeDate'
  },

  props: {
    expire: {
      type: String
    }
  },

  computed: {
    monthValue() {
      if (!this.expire) return ''
      const [month, year] = this.expire.split('/')
      if (month) return this.month = month.trim()
      return ''
    },

    yearValue() {
      if (!this.expire) return ''
      const [month, year] = this.expire.split('/')
      if (year) return this.year = year.trim()
      return ''
    }
  },

  mounted() {
    if (!this.expire) return ''
    const [month, year] = this.expire.split('/')
    if (month) this.month = month.trim()
    if (year) this.year = year.trim()
  }
})

class ExpireDateInput extends Vue {
  month = ''
  year = ''

  _formatMonth(month) {
    if (month === '') {
      return ''
    } else if (month === '0') {
      return ''
    } else if (month === '1') {
      return month
    } else {
      return month.padStart(2, '0')
    }
  }

  _formatYear(year) {
    if (year === '') {
      return ''
    } else {
      return year.padStart(2, '0')
    }
  }

  handleMonthInput(month) {
    this.month = month
    this.$emit('changeDate', this._formatMonth(this.month.trim()) + ' / ' + this.year.trim())
    setTimeout(() => {
      if (this.month.length >= 2) {
        this.$refs.creditCardYear.$el.getElementsByTagName('input')[0].focus()
      }
    }, 50)
  }

  handleYearInput(year) {
    this.year = year
    this.$emit('changeDate', this.month.trim() + ' / ' + this.year.trim())
    setTimeout(() => {
      if (year === '') {
        this.$refs.creditCardMonth.$el.getElementsByTagName('input')[0].focus()
      }
    }, 50)
  }

  handleBlur(val) {
    const value = this._formatYear(val)
    this.$emit('changeDate', this.month.trim() + ' / ' + value)
  }
}

export default ExpireDateInput
</script>
